module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og sørsamisk_sekundærlogo_neg(hvit).8f7acf3a.svg";